// extracted by mini-css-extract-plugin
export default {"closeModalButton":"customizedModalBase_closeModalButton__BwLWe"};